









































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DeductionTable from './deductionTable.vue';
import InspectionTemplatePreview from './inspectionTemplatePreview.vue';
import { Form } from '@ss/mtd-vue';

const validateName: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('模板名称不能为空'));
    }
    if (value.length > 30) {
        return callback(new Error('模板名称不能超过30个字'));
    }
    return callback();
};
const validateInstruction: Function = (_rule, value, callback) => {
    if (value && value.length > 100) {
        return callback(new Error('模板说明不能超过100个字'));
    }
    return callback();
};

@Component({
    components: {
        InspectionTemplatePreview,
        DeductionTable
    }
})
export default class InspectionTemplateEdit extends Vue {
    @Prop() inspectionForm: CommonTypes.mapObject;
    @Prop() basicForm: CommonTypes.mapObject;

    $refs: { totalForm: Form };
    btnLoading: boolean = false;
    isEditTotal: boolean = false;
    noteSwitch: boolean = false;
    noteRequired: boolean = false;
    totalPoints: number = 0;
    tableData: CommonTypes.mapObject[] = [];
    ruleCustom = {
        name: [{ validator: validateName, trigger: 'blur', required: true }],
        desc: [{ validator: validateInstruction, trigger: 'blur' }]
    };
    customBasicForm: CommonTypes.mapObject = {
        name: '',
        desc: ''
    };

    @Watch('inspectionForm', { immediate: true, deep: true })
    onFormChanged() {
        if (this.inspectionForm) {
            this.inspectionForm.systemFields.forEach(item => {
                switch (item.name) {
                    case 'totalPoints':
                        this.totalPoints = item.value;
                        break;
                    case 'noteSwitch':
                        this.noteSwitch = item.value;
                        break;
                    case 'noteRequired':
                        this.noteRequired = item.value;
                        break;
                    default:
                        break;
                }
            });
            this.tableData = Object.assign([], this.inspectionForm.deduction);
        }
    }
    @Watch('basicForm', { immediate: true })
    onBasicFormChanged() {
        this.customBasicForm = Object.assign({}, this.basicForm);
    }

    enterEdit() {
        this.isEditTotal = true;
        const ele: any = document.getElementById('totalInput').getElementsByClassName('mtd-input-number')[0];
        this.$nextTick(() => {
            ele.focus();
        });
    }
    totalSave() {
        if (this.totalPoints < 0) {
            this.$mtd.message({
                type: 'error',
                message: '初始分值必须为非负整数'
            });
            return;
        }
        this.isEditTotal = false;
        this.onChanged('totalPoints', this.totalPoints);
    }
    preventCheckEnter(e) {
        if (e.preventDefault) e.preventDefault();
        return false;
    }

    handleBasicChange(type: string, val: string) {
        this.$emit('basic-change', type, val);
    }
    onChanged(part: string, val) {
        this.$emit('change', part, val);
    }
    formChanged(val) {
        this.tableData = val;
        this.$emit('change', 'deduction', val);
    }

    preview() {
        this.$router
            .push({
                name: 'preview-inspection-form',
                query: {
                    ...this.$route.query
                }
            })
            .catch(e => e);
    }
    // 取消编辑
    cancelBack() {
        this.$mtd
            .confirm({
                message: '确定要离开吗？系统可能不会保存您所做的更改',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                onOk: () => {
                    this.$router.push(`/space/${this.spaceId}/quality-inspection-template`).catch(e => e);
                }
            })
            .catch(e => e);
    }

    get spaceId() {
        return parseInt(this.$route.query.spaceId as string, 10);
    }
    get formId() {
        return parseInt(this.$route.query.formId as string, 10);
    }
    get totalDeduction() {
        if (!this.tableData.length) return 0;
        let total: number = 0;
        this.tableData.forEach(ele => {
            total += ele.value || 0;
        });
        return total;
    }
}
